import { useEffect, useRef, useState } from "react";

/**
 * Compteur animé — anime vers `value` en ~600ms (easeOutCubic).
 * Fallback direct si prefers-reduced-motion.
 * `format` prend une valeur numérique et retourne une string.
 */
export default function AnimatedNumber({ value, format = (n) => String(Math.round(n)), duration = 600, className = "", ...rest }) {
  const [display, setDisplay] = useState(value);
  const from = useRef(value);
  const raf = useRef(null);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) { setDisplay(value); return; }
    const start = performance.now();
    const startVal = from.current;
    const end = value;
    const step = (now) => {
      const elapsed = now - start;
      const t = Math.min(1, elapsed / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(startVal + (end - startVal) * eased);
      if (t < 1) raf.current = requestAnimationFrame(step);
      else from.current = end;
    };
    raf.current = requestAnimationFrame(step);
    return () => raf.current && cancelAnimationFrame(raf.current);
  }, [value, duration]);

  return (
    <span className={`tabular-nums ${className}`} {...rest}>
      {format(display)}
    </span>
  );
}
